import React from "react";
import {
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Container,
  Grid,
} from "@mui/material";
import { Icon } from "@iconify/react";

export default function Ambiente() {
  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper
            elevation={3}
            sx={{
              p: { xs: 2, sm: 3 },
              borderRadius: 4,
              borderLeft: "8px solid #163e6a",
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
            >
              Requisito de autorización para intervención
              en lotes
            </Typography>

            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontSize: { xs: "1.1rem", sm: "1.2rem" } }}
            >
              Obligatoriedad de inspección y permiso previo
            </Typography>

            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 2 }}
            >
              Se informa a los propietarios y responsables de inmuebles la
              OBLIGATORIEDAD de tramitar la Autorización de la Dirección de
              Ambiente para la realización de las siguientes tareas en cualquier
              predio:
            </Typography>

            <List sx={{ mt: 1 }}>
              <ListItem sx={{ pl: 0 }}>
                <ListItemIcon>
                  <Icon icon="mdi:leaf" color="#163e6a" width={20} />
                </ListItemIcon>
                <ListItemText
                  primary="Limpieza de cobertura vegetal"
                  primaryTypographyProps={{
                    fontSize: "1rem",
                  }}
                />
              </ListItem>
              <ListItem sx={{ pl: 0 }}>
                <ListItemIcon>
                  <Icon icon="mdi:tree" color="#163e6a" width={20} />
                </ListItemIcon>
                <ListItemText
                  primary="Extracción, poda o tala de arbolado."
                  primaryTypographyProps={{
                    fontSize: "1rem",
                  }}
                />
              </ListItem>
            </List>

            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 2 }}
            >
              El procedimiento requiere la inspección ocular y dictamen técnico
              de esta Dirección ANTES de iniciar cualquier trabajo.
            </Typography>

            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 2 }}
            >
              Las intervenciones no autorizadas constituyen una infracción a las
              normativas vigentes, incluyendo:
            </Typography>

            <List sx={{ mt: 1 }}>
              <ListItem sx={{ pl: 0 }}>
                <ListItemIcon>
                  <Icon icon="mdi:file-document-outline" color="#163e6a" width={20} />
                </ListItemIcon>
                <ListItemText
                  primary='Art. 393, Ordenanza N° 628/18: Establece que "el propietario no podrá limpiar su lote sin antes tener la autorización de la Dir. Ambiente".'
                  primaryTypographyProps={{
                    fontSize: "1rem",
                  }}
                />
              </ListItem>
              <ListItem sx={{ pl: 0 }}>
                <ListItemIcon>
                  <Icon icon="mdi:file-document-outline" color="#163e6a" width={20} />
                </ListItemIcon>
                <ListItemText
                  primary='Art. 33, Ordenanza N° 725/21: Sanciona "Infringir las normas de arbolado".'
                  primaryTypographyProps={{
                    fontSize: "1rem",
                  }}
                />
              </ListItem>
            </List>

            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 2 }}
            >
              El incumplimiento de esta disposición resultará en las sanciones y
              multas previstas por la legislación municipal.
            </Typography>

            <Typography
              variant="body1"
              sx={{ fontSize: "1rem", mt: 2 }}
            >
              Para consultas y gestión de permisos, contacte a la Dirección de
              Ambiente de Lunes a Viernes de 8 a 14 hs.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
